export default "__VITE_ASSET__Cq0XTDXo__"